import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-spinner',
	templateUrl:'./WaSpinnerPage.html',
	styles: [],
	styleUrls:['./WaSpinnerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaSpinnerPage
{
	mdContent_452 = `\`\`\`java
import com.jwebmp.webawesome.components.spinner.WaSpinner;
\`\`\``;
	mdContent_453 = `\`\`\`java
var spinner = new WaSpinner<>();
spinner.setSize(Size.Large);
\`\`\``;
}
